<template>
  <v-app-bar
    color="blue-darken-3"
    elevation="0"
    app
    density="compact"
    theme="dark"
  >
    <v-toolbar-title class="flex-grow-0 flex-shrink-0"></v-toolbar-title>

    <v-avatar
      v-if="$store.getters.authenticated"
      size="30"
      class="mr-3"
      color="blue-darken-3"
    >
      <v-img
        src="../../assets/logo-white-30.png"
        max-width="30"
        max-height="30"
        contain
      ></v-img>
    </v-avatar>

    <base-main-nav-btn
      v-if="$store.getters.authenticated"
      to="/"
      icon="mdi-view-dashboard"
    >Dashboard</base-main-nav-btn>

    <base-main-nav-btn
      v-if="$store.getters.authenticated"
      to="/corporations"
      icon="mdi-domain"
    >Corporations</base-main-nav-btn>

    <base-main-nav-menu
      v-if="$store.getters.authenticated"
      label="Expenses"
      icon="mdi-cash"
      :items="expenseNavItems"
    ></base-main-nav-menu>

    <base-main-nav-btn
      v-if="$store.getters.authenticated"
      to="/asset-accounts"
      icon="mdi-bank-plus"
    >Assets</base-main-nav-btn>

    <base-main-nav-menu
      v-if="$store.getters.authenticated"
      label="Investors"
      icon="mdi-tie"
      :items="investorNavItems"
    ></base-main-nav-menu>

    <base-main-nav-menu
      v-if="$store.getters.authenticated"
      label="Customers"
      icon="mdi-account"
      :items="customerNavItems"
    ></base-main-nav-menu>

    <base-main-nav-menu
      v-if="$store.getters.authenticated"
      label="Catalog"
      icon="mdi-package-variant"
      :items="catalogNavItems"
    ></base-main-nav-menu>

    <base-main-nav-btn
      v-if="$store.getters.authenticated"
      to="/invoices"
    >Invoices</base-main-nav-btn>

    <base-main-nav-btn
      v-if="$store.getters.authenticated"
      to="/transactions"
    >Transactions</base-main-nav-btn>

    <base-main-nav-btn
      v-if="$store.getters.authenticated"
      to="/banks"
      icon="mdi-bank"
    >Banks</base-main-nav-btn>

    <base-main-nav-btn
      v-if="$store.getters.authenticated"
      to="/documents"
    >Documents</base-main-nav-btn>

    <v-spacer></v-spacer>

    <v-btn
      v-if="$store.getters.authenticated"
      to="/settings"
      icon
      class="mx-1"
      size="small"
    >
      <v-icon size="small">mdi-account-circle</v-icon>
    </v-btn>

    <div
      v-if="$store.getters.authenticated"
    >
      <v-tooltip v-if="$store.state.isDarkMode" location="bottom">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            size="small"
            icon
            @click="$store.dispatch('switchDarkMode', false)"
          >
            <v-icon size="small" color="yellow" class="mr-1">mdi-moon-waxing-crescent</v-icon>
          </v-btn>
        </template>
        <span>Disable dark mode</span>
      </v-tooltip>
      <v-tooltip v-else location="bottom">
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            size="small"
            icon
            @click="$store.dispatch('switchDarkMode', true)"
          >
            <v-icon size="small" color="yellow">mdi-white-balance-sunny</v-icon>
          </v-btn>
        </template>
        <span>Enable dark mode</span>
      </v-tooltip>
    </div>

    <v-divider
      v-if="$store.getters.authenticated"
      vertical
      class="ml-2 mr-4"
    ></v-divider>

    <v-btn
      class="main-nav-btn mx-2"
      size="small"
      variant="text"
      v-if="!$store.getters.authenticated"
      :to="{ name: 'Login' }"
    >
      <v-icon class="mr-1" size="small">mdi-login</v-icon>
      Login
    </v-btn>
    <v-btn
      class="mx-2"
      icon
      size="small"
      v-if="$store.getters.authenticated"
      @click="logoutConfirmation = true"
    >
      <v-icon size="small">mdi-logout</v-icon>
    </v-btn>
    <base-dialog-confirmation
      v-model="logoutConfirmation"
      prompt="Do you really want to logout?"
      confirm-text="Logout"
      confirm-color="red"
      @confirm="logout"
      @cancel="logoutConfirmation = false"
    ></base-dialog-confirmation>
  </v-app-bar>
</template>

<script>
export default {
  name: 'MainNav',

  data() {
    return {
      logoutConfirmation: false,
      expenseNavItems: [
        { title: 'Expense Accounts', to: '/expense-accounts', icon: 'mdi-bank-minus' },
        { title: 'Expense Categories', to: '/expense-categories', icon: 'mdi-format-list-bulleted' },
        { title: 'Expense Tags', to: '/expense-tags', icon: 'mdi-tag-multiple-outline' },
        { title: 'Expenses', to: '/expenses', icon: 'mdi-cash' },
      ],
      investorNavItems: [
        { title: 'Investors', to: '/investors', icon: 'mdi-tie' },
        { title: 'Investments', to: '/investments', icon: 'mdi-gold' },
        { title: 'Dividends', to: '/dividends', icon: 'mdi-cash-plus' },
      ],
      customerNavItems: [
        { title: 'Accounts', to: '/accounts', icon: 'mdi-account-cash' },
        { title: 'Customers', to: '/customers', icon: 'mdi-account' },
        { title: 'Subscriptions', to: '/subscriptions', icon: 'mdi-shopping' },
      ],
      catalogNavItems: [
        { title: 'Products', to: '/products', icon: 'mdi-package-variant-closed' },
        { title: 'Plans', to: '/plans', icon: 'mdi-tag' },
        { title: 'Coupons', to: '/coupons', icon: 'mdi-ticket-percent' },
      ],
    };
  },

  methods: {
    logout() {
      this.$emit('logout');
    },
  },
};
</script>
